import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LandmarkPanel } from '@form/lm-form.model';
import { LMUniqueIdService } from '@utils/lm-unique-id.service';
import { LMUrlInfoBuilderService } from '@services/lm-url-info-builder.service';

@Component({
  selector:    '[lm-page-pane-menu-component]', // tslint:disable-line
  templateUrl: './lm-page-pane-menu.component.html'
})
export class LMPagePaneMenuComponent implements AfterViewInit, OnInit {
  @Input() panel: LMMultiPagePaneSpec;
  @Input() set messageRuleView(messageRuleView: LMDataView) { // optional if used in a page panel
    this.m_messageRuleView = messageRuleView;
  }

  @Output() panelContentDisplayed = new EventEmitter<LMContentDisplayedEvent>();

  public m_messageRuleView: LMDataView = null;
  public panels: Array<LandmarkPanel>;
  public formUrlInfo: LMFormUrlInfo;
  public formSpec: LMFormSpec;

  constructor(
    private lmUniqueIdService: LMUniqueIdService,
    private lmUrlInfoBuilderService: LMUrlInfoBuilderService
  ) {}

  ngOnInit() {
    const menuFormPanelId = this.buildMenuPanelFormId()
    this.formSpec = {
      formElementId: menuFormPanelId,
      busFormSpec:   this.buildBusFormSpec(),
      busClassSpec:  this.buildBusClassSpec(),
      resourceId:    menuFormPanelId
    };
    this.formUrlInfo = this.lmUrlInfoBuilderService.getFormUrlInfoFromFormSpec(this.formSpec);
  }

  ngAfterViewInit() {
  }

  onFormRendered(args: any) {
    const event: LMContentDisplayedEvent = { pane: this.panel, args };
    this.panelContentDisplayed.emit(event);
  }

  buildBusFormSpec(): LMBusFormSpec {

    const busFormLayoutSpec: LMBusFormLayoutSpec = {
      layout: this.panel.pane.menuPanelLayout
    };

    const messageRule: LMMessageRule = {
      resourceValue: '',
    };

    const busFormSpec: LMBusFormSpec = {
      busFormLayoutSpec,
      name:                     '',
      fields:                   {},
      title:                    messageRule,
      formType:                 'Menu',
      effectiveDateField:       {},
      effectiveDateFieldId:     '',
      reasonCodeFieldId:        '',
      actionCommentFieldId:     '',
      effectiveThroughFieldId:  '',
      correctionCommentFieldId: '',
      openActionRestricted:     false,
      implementsDashBoardView:  false,
    };
    return busFormSpec;
  }

  buildBusClassSpec(): LMBusClassSpec {

    const busClassSpec: LMBusClassSpec = {
      actions:                [],
      actionSpec:             {},
      implAuditing:           false,
      implEffectiveDated:     false,
      isBusClass:             false,
      isBusTask:              false,
      name:                   'menuPanel',
      implementsOrgChartView: false,
    };
    return busClassSpec;
  }

  private buildMenuPanelFormId() {
    return this.lmUniqueIdService.uniqueId([ this.panel.paneId, 'MenuPanel' ]);
  }
}
